import React from 'react'
import BaseComponent from './components/BaseComponent'
import { withRouter, Switch, Route } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import 'custom-event-polyfill'
import Header from './components/Header'
import ErrorPage from './components/ErrorPage'
import LoginPage from './components/LoginPage'
import HomePage from './components/HomePage'
import SideNav from './components/SideNav'
import ListPage from './components/ListPage'
import AddPage from './components/AddPage'
import EditPage from './components/EditPage'
import SettingsPage from './components/SettingsPage'
import UserPage from './components/UserPage'
import HeatMap from './components/HeatMap'
import '../style.css'

class MainView extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { screen : { width: window.innerWidth, height: window.innerHeight }, user: this.props.user, loggedIn: this.props.loggedIn, nav: true, notifications: [] }
    this._bind('loginSuccess', 'logout', 'toggleNav', 'hideNav', 'addNotify', 'closeNotify', 'checkSession')
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize.bind(this))
    if (this.state.screen.width < 1020) {
      this.setState({ nav: false })
    }
    window.addEventListener("NOTIFY", (data) => { this.addNotify(data) })

    setInterval(this.checkSession, 10000)
  }

  checkSession() {
    if (this.state.loggedIn) {
      let data  = {}
      fetch(this.props.API+"/auth/validate", {
        method: "POST",
        headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer " + sessionStorage.getItem('token')
          },
        body: JSON.stringify(data)
      })
      .then((response) => {
          return response.json()
      })
      .then((result) => {
        if (result.data.status === false) {
          this.logout()
        }
      }, (error) => {
        console.log(error)
      })
    }
  }

  addNotify(e) {
    let stamp = new Date()
    stamp = stamp.getTime()
    let temp = this.state.notifications
    let item = { type: e.detail.type, content: e.detail.content, stamp: stamp }
    temp.push(item)
    this.setState({ notifications: temp })
    setTimeout(() => {
      this.closeNotify(stamp)
    }, 8000)
  }

  closeNotify(stamp) {
    let index = 999
    let temp = this.state.notifications
    for (var i = 0; i < this.state.notifications.length; i++) {
      if(this.state.notifications[i].stamp === stamp) {
        index = i
      }
    }
    temp.splice(index, 1);
    this.setState({ notifications: temp })
  }

  scrollTop() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      setTimeout(this.scrollTop, 200)
    }
  }

  handleResize(e) {
    this.setState({ screen : { width: window.innerWidth, height: window.innerHeight }, nav: window.innerWidth < 1020 ? false : true})
  }

  loginSuccess(data) {
    this.setState({ loggedIn: true, user: { name: data.name ? data.name : data.login, role: data.userRole ? data.userRole[0].title : null, userId: data.id } })
    let redirect = "/"
    if (this.props.location.hash.indexOf("#redirect=") !== -1) {
      redirect = this.props.location.hash.replace("#redirect=", "")
    }
    this.props.history.push(redirect)
  }

  logout() {
    fetch(this.props.API+'/auth/logout', {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer " + sessionStorage.getItem('token')
      }
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      sessionStorage.removeItem('token')
      this.setState({ loggedIn: false, user: { name: "" } })
      this.props.history.push("/login#redirect="+this.props.location.pathname)
    }, (error) => {
      console.log(error)
    })
  }

  toggleNav() {
    if (this.state.nav) {
      this.setState({ nav: false })
    } else {
      this.setState({ nav: true })
    }
  }

  hideNav() {
    if (this.state.screen.width < 1020) {
      this.setState({ nav: false })
    }
  }

  render() {
    let routes = this.props.data.pages.map((item, i) => {
      return (
          <Route key={ i+"-list" } path={ item.route } exact render={(props) => (<ListPage data={ item } API={ this.props.API } user={ this.state.user } templates={ this.props.data.templates } screen={ this.state.screen } location={ this.props.location } sessionId = { this.props.sessionId } {...props}/>)}/>
      )
    })

    let routesEdit = this.props.data.pages.map((item, i) => {
      return (
          <Route key={ i+"-edit" } path={ item.editLink } exact render={(props) => (<EditPage data={ item } API={ this.props.API } user={ this.state.user } templates={ this.props.data.templates } screen={ this.state.screen } location={ this.props.location } sessionId = { this.props.sessionId } {...props}/>)}/>
      )
    })

    let routesAdd = this.props.data.pages.map((item, i) => {
      return (
          <Route key={ i+"-add" } path={ item.new } exact render={(props) => (<AddPage data={ item } API={ this.props.API } user={ this.state.user } templates={ this.props.data.templates } screen={ this.state.screen } location={ this.props.location } sessionId = { this.props.sessionId } {...props}/>)}/>
      )
    })

    let notifications = this.state.notifications.map((item, i) => {
      return (
        <CSSTransition key={ item.stamp } classNames="notification" timeout={{ enter: 500, exit: 500 }} >
          <div className={ "notification " + item.type } style={{ transform: "translateY("+(i*50)+"px)" }} onClick={ this.closeNotify.bind(null, item.stamp) }>
            <div className="close"></div>
            <p>{ item.content }</p>
          </div>
        </CSSTransition>
      )
    })

    return (
      <div className="app-inner">
        { this.state.loggedIn ? <Header data={ this.props.data } location={ this.props.location } user={ this.state.user } loggedIn={ this.state.loggedIn } logout={ this.logout } toggleNav={ this.toggleNav } nav={ this.state.nav }/> : null }
        { this.state.loggedIn ? <SideNav data={ this.props.data } user={ this.state.user } loggedIn={ this.state.loggedIn } hideNav={ this.hideNav } nav={ this.state.nav }/> : null }
        <TransitionGroup className={ this.state.nav ? "page-holder open" : "page-holder" }>
          <CSSTransition key={ this.props.location.pathname } classNames="page" timeout={{ enter: 400, exit: 200 }} >
            <Switch location={ this.props.location }>
              <Route  path="/" exact render={(props) => (<HomePage data={ this.props.data } API={ this.props.API } screen={ this.state.screen } location={ this.props.location } user={ this.state.user } loggedIn={ this.state.loggedIn } sessionId = { this.props.sessionId }/>)}/>
              <Route  path="/login" exact render={(props) => (<LoginPage data={ this.props.data } API={ this.props.API } screen={ this.state.screen } location={ this.props.location } loginSuccess={ this.loginSuccess } sessionId = { this.props.sessionId }/>)}/>
              <Route key={ "settings-page" } path="/ustawienia" exact render={(props) => (<SettingsPage data={ this.props.data.settings } API={ this.props.API } templates={ this.props.data.templates } screen={ this.state.screen } location={ this.props.location } sessionId = { this.props.sessionId } {...props}/>)}/>
              <Route  path="/heatmapa" exact render={(props) => (<HeatMap nav={ this.state.nav } API={ this.props.API } user={ this.state.user } templates={ this.props.data.templates } screen={ this.state.screen } location={ this.props.location } sessionId = { this.props.sessionId } {...props}/>)}/>
              { routes }
              { routesAdd }
              { routesEdit }
              <Route key={ "user-page" } path={ this.props.data.user.route } exact render={(props) => (<UserPage data={ this.props.data.user } user={ this.state.user } API={ this.props.API } templates={ this.props.data.templates } screen={ this.state.screen } location={ this.props.location } sessionId = { this.props.sessionId } {...props}/>)}/>
              <Route render={(props) => (<ErrorPage data={ this.props.data }/>)} />
            </Switch>
          </CSSTransition>
        </TransitionGroup>
        <TransitionGroup className="notifications">
          { notifications }
        </TransitionGroup>
      </div>
    )
  }
}

export default withRouter(MainView)


// WEBPACK FOOTER //
// ./src/app/MainView.js